"use client";

import { cn } from "@tosize/ui";
import { useFormContext } from "react-hook-form";
import { type CommandDialogType, useCommand } from "~/app/[lang]/command/Context";
import {
	type ListImportFormType,
	defaultImportSchemaItem,
} from "~/app/[lang]/command/dialogs/import/schema";

interface ImportTabsProps {
	fileTitle: string;
	listTitle: string;
}

export function ImportTabs({ fileTitle, listTitle }: ImportTabsProps) {
	const form = useFormContext<ListImportFormType>();
	const { activeDialog, setActiveDialog } = useCommand();

	const setActiveDialogHandler = (dialog: CommandDialogType) => {
		setActiveDialog(dialog);

		if (dialog === "importProducts_list") {
			form.setValue("items", [defaultImportSchemaItem]);
		}

		if (dialog === "importProducts_file") {
			form.setValue("items", []);
		}
	};

	return (
		<div className="-mt-0.5 flex gap-4 border-shades-light border-b-2">
			<button
				type="button"
				onClick={() => setActiveDialogHandler("importProducts_list")}
				className={cn(
					"-mb-0.5 relative border-b-2 py-1 font-bold focus:outline-none motion-safe:transition-colors",
					{
						"border-transparent enter:border-shades": activeDialog !== "importProducts_list",
						"border-primary-medium enter:border-primary-dark":
							activeDialog === "importProducts_list",
					},
				)}
			>
				{listTitle}
			</button>

			<button
				type="button"
				onClick={() => setActiveDialogHandler("importProducts_file")}
				className={cn(
					"-mb-0.5 relative border-b-2 py-1 font-bold focus:outline-none motion-safe:transition-colors",
					{
						"border-transparent enter:border-shades": activeDialog !== "importProducts_file",
						"border-primary-medium enter:border-primary-dark":
							activeDialog === "importProducts_file",
					},
				)}
			>
				{fileTitle}
			</button>
		</div>
	);
}
